import { IMemberProps } from 'common/interface/props';
import ShopLoginForm from 'components/UI/organisms/ShopLoginForm';
import Container from 'components/UI/atoms/Container';

export default function ShopLogin({ solType }: IMemberProps) {
  return (
    <>
      {/* <Banner imgPath="/images/bg_title4.png" text="사이트 선택" /> */}

      <Container noBody={true}>
        <ShopLoginForm solType={solType} />
      </Container>
    </>
  );
}
